<div class="app-root">
    <div *ngIf="isNotProd" class="environmentLabel">
        {{ environmentName }}
    </div>
    <div class="app-content">
        <app-main-header
            *ngIf="identity"
            [identity]="identity"
            [menuItems]="menuItems"
            [isDev]="isDev"
            [isProd]="isProd"
            (logout)="handleLogout()"></app-main-header>

        <div class="route-container">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
